import { yupResolver } from "@hookform/resolvers/yup";
import { Dialog, Stack, TextField, Typography, Button, CircularProgress } from "@mui/material";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";

interface AlterarPrecoFreteModalProps {
    open: boolean;
    valorAtual?: number;
    onClose: () => void;
    onConfirm: (novoValor: number) => void;
    loading?: boolean;
}

interface AlterarPrecoFreteFormValues {
    valorFrete: string;
}

const schema = yup.object({
    valorFrete: yup
        .string()
        .required("Informe o valor do frete")
        .test("is-number", "Valor inválido", (value) => {
            if (!value) return false;
            const normalized = value.replace(",", ".").trim();
            const parsed = Number(normalized);
            return !isNaN(parsed) && parsed >= 0;
        }),
});

export const AlterarPrecoFreteModal = ({
    open,
    valorAtual,
    onClose,
    onConfirm,
    loading,
}: AlterarPrecoFreteModalProps) => {
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
    } = useForm<AlterarPrecoFreteFormValues>({
        resolver: yupResolver(schema),
        mode: "onChange",
        defaultValues: {
            valorFrete: valorAtual !== undefined ? String(valorAtual).replace(".", ",") : "",
        },
    });

    useEffect(() => {
        if (open) {
            setValue(
                "valorFrete",
                valorAtual !== undefined ? String(valorAtual).replace(".", ",") : ""
            );
        }
    }, [open, valorAtual, setValue]);

    const handleClose = () => {
        reset();
        onClose();
    };

    const onSubmit = (values: AlterarPrecoFreteFormValues) => {
        const normalized = values.valorFrete.replace(",", ".").trim();
        const parsed = Number(normalized);
        if (isNaN(parsed) || parsed < 0) {
            return;
        }
        onConfirm(parsed);
    };

    return (
        <Dialog open={open} onClose={handleClose} sx={{ zIndex: 99999 }}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Stack spacing={2} sx={{ padding: "1.5rem", minWidth: 320 }}>
                    <Typography variant="h6">Alterar preço do frete</Typography>
                    <TextField
                        label="Valor do frete"
                        fullWidth
                        {...register("valorFrete")}
                        error={!!errors.valorFrete}
                        helperText={errors.valorFrete?.message}
                        inputProps={{ inputMode: "decimal" }}
                    />
                    <Stack direction="row" spacing={2} justifyContent="space-between">
                        <Button
                            variant="outlined"
                            type="button"
                            onClick={handleClose}
                            sx={{ width: "47%" }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            variant="contained"
                            type="submit"
                            sx={{ width: "47%" }}
                            disabled={!!loading}
                        >
                            {loading ? (
                                <CircularProgress
                                    sx={{ width: "15px", height: "15px" }}
                                    color="inherit"
                                />
                            ) : (
                                "Confirmar"
                            )}
                        </Button>
                    </Stack>
                </Stack>
            </form>
        </Dialog>
    );
}


